import p4Img1 from "./imgs/p4_img1.png";
import p4Img2 from "./imgs/p4_img2.png";
import p4Img3 from "./imgs/p4_img3.png";
import p4Img4 from "./imgs/p4_img4.png";
import p5Img1 from "./imgs/p5_img1.png";
import p5Img2 from "./imgs/p5_img2.png";
import p5Img3 from "./imgs/p5_img3.png";
import p5Img4 from "./imgs/p5_img4.png";

const p4List = [
  {
    img: p4Img1,
  },
  {
    img: p4Img2,
  },
  {
    img: p4Img3,
  },
  {
    img: p4Img4,
  },
];

const data = {
  p1: {
    title: "必搜-GEO搜索产品",
    subtitle: "抢占AI搜索流量红利",
  },
  p2: {
    title: "AI搜索对企业的巨大价值",
    subtitle: <>你的竞争对手们，<span>已经全面布局</span>AI搜索了</>,
    mobile_subtitle: <>你的竞争对手们，<br/><span>已经全面布局</span>AI搜索了</>,
  },
  p3: {
    title: "对企业来说，到底什么是GEO",
  },
  p4: {
    title: "为什么GEO是企业营销的必杀技",
    mobile_title: <>为什么GEO是<br/>企业营销的必杀技</>,
    list: p4List,
  },
  p5: {
    title: "产品优势",
    list: [
      {
        img: p5Img1,
        title: (
          <>
            <span>深度挖掘</span>AI搜索的企业关键词
          </>
        ),
      },
      {
        img: p5Img2,
        title: (
          <>
            一站式GEO服务，“AI广告”<span>效果持久！</span>
          </>
        ),
      },
      {
        img: p5Img3,
        title: (
          <>
            主流大模型平台，<span>一次全面覆盖</span>
          </>
        ),
      },
      {
        img: p5Img4,
        title: (
          <>
            <span>老板随时随地可查看</span>，效果看得见! 投资回报看得见!
          </>
        ),
      },
    ],
  },
  p6: {
    title: "服务流程 - 树立AI广告牌的“独门秘籍”",
    subtitle: <>小冰科技深耕人工智能行业十余年 <br />洞悉大模型底层逻辑，精准驾驭流量运行规律 <br /><span>让您的品牌成为AI首选</span></>,
    mobile_title: <>服务流程<br />树立AI广告牌的“独门秘籍”</>
  }
};
export default data;
